import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const monthNames = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export const MonthNavigator = ({ month, year, onPrev, onNext }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1,
    }}
  >
    <IconButton onClick={onPrev} size="small">
      <ChevronLeftIcon />
    </IconButton>
    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
      {monthNames[month]} {year}
    </Typography>
    <IconButton onClick={onNext} size="small">
      <ChevronRightIcon />
    </IconButton>
  </Box>
);
